
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ActionButton extends Vue {
    @Prop({ default: false }) disabled!: boolean;
    @Prop({ default: false }) loading!: boolean;
    @Prop({ default: "submit" }) type!: string;
}
